import {
  faCircleCheck as seenCheckIcon,
  faCircle as newDocumentIcon,
} from "@fortawesome/pro-solid-svg-icons";
import { faCheck as unSeenCheckIcon } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Box, Typography } from "@vapor/react-material";
import { useDocumentList } from "../../state/useDocumentList";
import VaporIconBase from "@vapor/react-icons/VaporIconBase";
import Grid from "@vapor/react-material/Grid";
import { useTranslation } from "@onefront/react-sdk";

const SeenUnseenCell = ({ status }) => {
  const { t } = useTranslation("DOCS");

  const checkIcon = (status) => {
    if (status === "READ") {
      return {
        icon: seenCheckIcon,
        message: t("document.statusRead"),
        color: "success",
      };
    } else if (status === "UNREAD") {
      return {
        icon: unSeenCheckIcon,
        message: t("document.statusUnread"),
        color: "info",
      };
    } else if (status === "NEW") {
      return { icon: newDocumentIcon, message: t("document.statusNew") };
    }
  };
  const display = checkIcon(status);
  const { documentFilterOption } = useDocumentList();
  return (
    <>
      {documentFilterOption !== "CESTINO" && (
        <Grid item sm={6}>
          {/* A solution to give linear gradient to newDocumentIcon */}
          <svg width="0" height="0" style={{ position: "absolute" }}>
            <defs>
              <linearGradient
                id="newDocumentIconGradient"
                x1="0%"
                y1="0%"
                x2="100%"
                y2="100%"
              >
                <stop offset="0%" stopColor="#00BFE6" />
                <stop offset="100%" stopColor="#0090D1" />
              </linearGradient>
            </defs>
          </svg>
          <style>
            {`
          .gradient-icon path {
            fill: url(#newDocumentIconGradient) !important;
          }
        `}
          </style>
          <Box
            alignItems="center"
            direction="row"
            display="flex"
            gap="8px"
            width="100px"
          >
            {status === "NEW" ? (
              <FontAwesomeIcon
                className="gradient-icon"
                icon={newDocumentIcon}
              />
            ) : (
              <VaporIconBase color={display?.color} icon={display?.icon} />
            )}
            <Typography noWrap variant="body">
              {display?.message}
            </Typography>
          </Box>
        </Grid>
      )}
    </>
  );
};

export default SeenUnseenCell;
